<!--
  Muestra el logotipo horizontal de Planer con la variante adecuada al tema del panel.
  Cada variante es una imagen independiente porque un img no hereda currentColor.

  --logo-height controla la altura y la proporción de la imagen determina el ancho.
-->
<script lang="ts">
  import logoLight from "../assets/planer-logo.svg";
  import logoDark from "../assets/planer-logo-white.svg";
  import { cx } from "../lib/cx";
  import { theme } from "../lib/theme.svelte";

  let {
    height = "1.25rem",
    id,
    class: className,
  }: {
    /** Lo alto que se dibuja; la anchura sale sola. */
    height?: string;
    id?: string;
    class?: string;
  } = $props();

  const src = $derived(theme.name === "dark" ? logoDark : logoLight);
</script>

<img {id} {src} alt="Planer" class={cx("brand-logo", className)} style="--logo-height: {height}" />

<style>
  .brand-logo {
    display: block;
    width: auto;
    height: var(--logo-height);
  }
</style>
